export default __webpack_public_path__ + "static/media/top-senior.a83c253f.png";